import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const slides = [
  {
    img: '/img/bishopindiaresizednew.jpg',
    tag: 'Join Our',
    title: 'Humanitarian Ministry',
    sub: 'Reaching the poor, hungry, and hurting in communities worldwide.',
    btn: 'Click to Donate',
    btnLink: 'https://www.paypal.com/donate',
  },
  {
    img: '/img/missioninindia.jpg',
    tag: 'Growing Together',
    title: 'Soul Winning Outreaches',
    sub: 'Taking the Gospel to the poor and rich through evangelism and programs.',
    btn: 'Learn More',
    btnLink: '/programs',
    internal: true,
  },
  {
    img: '/img/newbirthbuilding.JPG',
    tag: 'Strengthening the Body',
    title: 'Equipping Ministers',
    sub: 'Empowering pastors and churches with knowledge, licensing, and fellowship.',
    btn: 'Discover Programs',
    btnLink: '/programs',
    internal: true,
  },
];

function Hero() {
  const [current, setCurrent] = useState(0);
  const timerRef = useRef(null);

  const go = (idx) => {
    clearTimeout(timerRef.current);
    setCurrent((idx + slides.length) % slides.length);
  };

  useEffect(() => {
    timerRef.current = setTimeout(() => go(current + 1), 5500);
    return () => clearTimeout(timerRef.current);
  });

  const s = slides[current];

  return (
    <section className="hero">
      {slides.map((sl, i) => (
        <div
          key={i}
          className={`hero-slide${i === current ? ' active' : ''}`}
          style={{ backgroundImage: `url(${sl.img})` }}
        />
      ))}
      <div className="hero-overlay" />
      <div className="hero-content">
        <p className="hero-tag">{s.tag}</p>
        <h1 className="hero-title">{s.title}</h1>
        <p className="hero-sub">{s.sub}</p>
        <div className="hero-btns">
          {s.internal ? (
            <Link to={s.btnLink} className="btn-primary-gold">{s.btn}</Link>
          ) : (
            <a href={s.btnLink} className="btn-primary-gold" target="_blank" rel="noreferrer">{s.btn}</a>
          )}
          <Link to="/about" className="btn-outline-white">Our Mission</Link>
        </div>
      </div>

      <div className="hero-controls">
        <button className="hero-arrow prev" onClick={() => go(current - 1)} aria-label="Previous">&#8592;</button>
        <div className="hero-dots">
          {slides.map((_, i) => (
            <button
              key={i}
              className={`dot${i === current ? ' active' : ''}`}
              onClick={() => go(i)}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
        <button className="hero-arrow next" onClick={() => go(current + 1)} aria-label="Next">&#8594;</button>
      </div>
    </section>
  );
}

function Stats() {
  const items = [
    { num: '400+', label: 'Member Churches' },
    { num: '3', label: 'Continents Reached' },
    { num: '35+', label: 'Years of Ministry' },
    { num: '1000+', label: 'Lives Impacted' },
  ];
  return (
    <section className="stats-bar">
      {items.map(({ num, label }) => (
        <div key={label} className="stat-item">
          <span className="stat-num">{num}</span>
          <span className="stat-label">{label}</span>
        </div>
      ))}
    </section>
  );
}

function WelcomeSection() {
  return (
    <section className="welcome-section">
      <div className="container welcome-grid">
        <div className="welcome-img-wrap">
          <img src="/img/bishopbryan.jpeg" alt="Bishop Bryan" className="welcome-img" />
          <div className="welcome-badge">
            <span>35+</span>
            <p>Years of Ministry</p>
          </div>
        </div>
        <div className="welcome-text">
          <p className="section-label">Welcome</p>
          <h2 className="section-title">What We Are <span>All About</span></h2>
          <p>
            The most important objective of New Birth Church of Christ International is winning
            souls for the Kingdom of heaven, to support and strengthen every pastor and the
            members of their congregations.
          </p>
          <p style={{ marginTop: '1rem' }}>
            Also to bring about a strong unification in the Body of Christ, to help individual
            churches with humanitarian needs within their villages, cities and countries, and to
            provide Spiritual guidance and professional counselling to every Pastor and minister.
          </p>
          <div className="welcome-features">
            <div className="feature-item">
              <span className="feature-icon">✝</span>
              <span>Soul Winning Priority</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🤝</span>
              <span>Church Unity</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">❤</span>
              <span>Humanitarian Care</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📖</span>
              <span>Minister Training</span>
            </div>
          </div>
          <Link to="/about" className="btn-primary-gold" style={{ marginTop: '1.8rem', display: 'inline-block' }}>
            Read Our Story
          </Link>
        </div>
      </div>
    </section>
  );
}

function Programs() {
  const programs = [
    {
      icon: '❤',
      title: 'Humanitarian Work',
      desc: 'As we travel around the world we see too many suffering — too many hungry and hurting people, especially children in poverty. Matthew 25:35-40 is our calling.',
      img: '/img/humanitarian.JPG',
      link: '/programs',
    },
    {
      icon: '📖',
      title: 'Equipping Ministers',
      desc: 'We believe in equipping ministers with biblical and academic knowledge to enable them to represent Christ substantially and excel in their various ministries.',
      img: '/img/trainingministers.JPG',
      link: '/programs',
    },
    {
      icon: '✝',
      title: 'Soul Winning Outreaches',
      desc: 'Soul winning is our priority. What shall it profit a man to gain the whole world and lose his soul? We commit to winning souls through evangelism and programs.',
      img: '/img/outreach.JPG',
      link: '/programs',
    },
  ];

  return (
    <section className="programs-section">
      <div className="container">
        <div className="section-header-center">
          <p className="section-label">What We Do</p>
          <h2 className="section-title">Our Programs & <span>Activities</span></h2>
        </div>
        <div className="programs-grid">
          {programs.map(({ icon, title, desc, img, link }) => (
            <div key={title} className="program-card">
              <div className="program-img" style={{ backgroundImage: `url(${img})` }}>
                <div className="program-overlay" />
                <span className="program-icon">{icon}</span>
              </div>
              <div className="program-body">
                <h3>{title}</h3>
                <p>{desc}</p>
                <Link to={link} className="program-link">Learn More →</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function MissionBanner() {
  return (
    <section
      className="mission-banner"
      style={{ backgroundImage: 'url(/img/missioninindia.jpg)' }}
    >
      <div className="mission-overlay" />
      <div className="container mission-content">
        <p className="section-label" style={{ color: 'var(--gold-light)' }}>Our Vision</p>
        <h2 style={{ color: '#fff', fontSize: '2.5rem', maxWidth: '700px' }}>
          Uniting Churches Across the Globe for Christ
        </h2>
        <p style={{ color: 'rgba(255,255,255,0.85)', maxWidth: '600px', margin: '1rem auto 2rem' }}>
          From Toronto to India, Africa to Europe — New Birth CCCI is building a global fellowship
          of over 400 churches committed to the Great Commission.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/about" className="btn-primary-gold">Our Story</Link>
          <Link to="/contact" className="btn-outline-white">Get In Touch</Link>
        </div>
      </div>
    </section>
  );
}

function Events() {
  const events = [
    {
      img: '/img/FUNDGOSPLECONCER.jpg',
      date: 'August 2022',
      title: 'Gospel Concert & Fundraiser',
      desc: 'A fund raising event for the upcoming official launch of New Birth Church of Christ International.',
    },
    {
      img: '/img/newbirthlunch.jpeg',
      date: 'August 2022',
      title: 'Official Launch of New Birth Organization',
      desc: 'The official launch of New Birth CCCI in Toronto, Canada with over 400 churches coming together.',
    },
  ];

  return (
    <section className="events-home">
      <div className="container">
        <div className="section-header-center">
          <p className="section-label">What's Happening</p>
          <h2 className="section-title">Upcoming <span>Events</span></h2>
        </div>
        <div className="events-grid">
          {events.map(({ img, date, title, desc }) => (
            <div key={title} className="event-card">
              <div className="event-img-wrap">
                <img src={img} alt={title} />
                <div className="event-date-badge">{date}</div>
              </div>
              <div className="event-body">
                <h3>{title}</h3>
                <p>{desc}</p>
                <Link to="/events" className="program-link">View Details →</Link>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
          <Link to="/events" className="btn-primary-gold">View All Events</Link>
        </div>
      </div>
    </section>
  );
}

function Contact() {
  return (
    <section className="home-contact">
      <div className="container home-contact-grid">
        <div className="hc-text">
          <p className="section-label">Reach Out</p>
          <h2 className="section-title">For Prayer Request <span>& Query</span></h2>
          <p>
            Whether you need prayer, want to join our fellowship, or are a pastor looking to
            connect with our international network — we'd love to hear from you.
          </p>
          <ul className="hc-info-list">
            <li>📍 2240 Kipling Avenue, Toronto, Canada</li>
            <li>📞 <a href="tel:+14168579811">+1-416-857-9811</a></li>
            <li>✉ <a href="mailto:nbirthcci@gmail.com">nbirthcci@gmail.com</a></li>
          </ul>
        </div>
        <form className="hc-form" onSubmit={e => e.preventDefault()}>
          <div className="form-row">
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
          </div>
          <input type="text" placeholder="Subject" />
          <textarea placeholder="Your Message" rows={5} required />
          <button type="submit" className="btn-primary-gold">Send Message</button>
        </form>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <WelcomeSection />
      <Programs />
      <MissionBanner />
      <Events />
      <Contact />
    </>
  );
}
